import React, { useState } from 'react'

import { Villain } from "../components/about/Villain";
import { Latest } from "../components/about/Latest";
import { Statistics } from '../components/about/Statistics';
import { Social } from '../components/about/Social';
import { Dance } from "../components/about/Dance";
import { WishList } from "../components/about/WishList";
import { useFetch } from "../hooks/useFetch";
import { DATA_BASE_URL } from "../config";

export const AboutPage = () => {
  // Created once on mount, so children receive the same date on every re-render
  const [currentDate] = useState(() => new Date());

  const { data } = useFetch(`${DATA_BASE_URL}/about.json`);
  const {
    revisionDate = "",
    currently = [],
    homeServerUrl = "",
    spotifyUrl = "",
    fitBitUrl = "",
    tweetUrl = "",
    dances = [],
    wishlists = []
  } = data ?? {};

  return (
    <div>
        <Villain currentDate={currentDate} homeServerUrl={homeServerUrl} revisionDate={revisionDate} currently={currently}/>
        <Latest />
        <Statistics currentDate={currentDate} spotifyUrl={spotifyUrl} fitBitUrl={fitBitUrl} tweetUrl={tweetUrl}/>
        <Social />
        <Dance dances={dances} />
        <WishList wishlists={wishlists} />
    </div>
  )
}
